import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Sparkles, ShieldCheck } from 'lucide-react';
import { estadoCombo, estadoForzado } from './comboIA';
import ComboIAVenta from './ComboIAVenta';

/* Puerta del combo "IA de obra" para Buscador de obra / Entradas y salidas / Materiales / Acopio.
   - Sin el combo: pantalla de venta (ComboIAVenta) en lugar de la página.
   - En prueba: banda chica "Te quedan N días de prueba" arriba de la página.
   - Activo: la página tal cual.
   Lisual (admin) siempre ve la página; si el cliente no lo tiene, con una banda gris que lo dice.
   Si el estado no se puede leer (backend caído), se muestra la página: nunca se le corta a quien paga. */

const DIA = 86400000;
/** Acepta la respuesta nueva (estado) y la del backend viejo del adicional de entregas (contratado/status). */
export function normalizar(r) {
  if (!r) return null;
  if (r.estado) return r;
  const tiene = !!(r.contratado && r.feedIncluido);
  const prueba = tiene && r.status === 'trialing' && !r.cortesia;
  const dias = prueba && r.trialEnd ? Math.max(0, Math.ceil((new Date(r.trialEnd).getTime() - Date.now()) / DIA)) : null;
  return { ...r, estado: tiene ? (prueba ? 'prueba' : 'activo') : 'no', diasRestantes: dias };
}

const BandaPrueba = ({ dias }) => (
  <div className="mb-4 flex items-start gap-2 rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-900" data-combo-banda="prueba">
    <Sparkles size={16} className="text-emerald-600 shrink-0 mt-0.5" />
    <span>
      <b>IA Pro en prueba:</b> ya estamos analizando tu obra con IA;{' '}
      {dias === 0 ? 'hoy es el último día de prueba' : dias === 1 ? 'te queda 1 día de prueba' : `te quedan ${dias ?? 30} días de prueba`}.{' '}
      <span className="text-emerald-800/80">Sin compromiso: cancelás cuando quieras.</span>
    </span>
  </div>
);

const BandaAdmin = () => (
  <div className="mb-4 flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-600" data-combo-banda="admin">
    <ShieldCheck size={14} className="shrink-0" />
    Vista de Lisual: este cliente todavía no tiene IA de obra en esta cámara (él ve la pantalla de venta).
  </div>
);

const ComboIAGate = ({ feedID, pagina, children }) => {
  const forzado = estadoForzado();
  const [estado, setEstado] = useState(forzado);
  const [error, setError] = useState(false);

  const cargar = useCallback((refrescar) => {
    if (forzado || !feedID) return;
    setError(false);
    estadoCombo(feedID, { refrescar }).then((r) => setEstado(normalizar(r))).catch(() => setError(true));
  }, [feedID, forzado]);
  useEffect(() => { cargar(false); }, [cargar]);

  if ((!feedID && !forzado) || error) return children;
  if (!estado) {
    return <div className="flex items-center gap-2 text-sm text-gray-500 py-10 justify-center"><Loader2 size={16} className="animate-spin" />Cargando…</div>;
  }
  if (estado.estado === 'no') {
    if (estado.admin) return <><BandaAdmin />{children}</>;
    return <ComboIAVenta feedID={feedID} pagina={pagina} estado={estado} onSimularAlta={() => setEstado({ ...estado, estado: 'prueba', diasRestantes: 30 })} onActivado={(r) => setEstado(normalizar(r))} />;
  }
  return (
    <>
      {estado.estado === 'prueba' && <BandaPrueba dias={estado.diasRestantes} />}
      {children}
    </>
  );
};

export default ComboIAGate;
